export default __webpack_public_path__ + "static/media/AlyaLovelace.1b140fb8.png";